import { METHOD_POST } from 'requests';

import { CUSTOMER_POSITIONS, CUSTOMER_TEAMS } from 'constants/endpoints';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_POST_editRankingTieringCSV = (params: {
  formData: FormData;
  selectedCommunity: number;
  selectedPosition: string;
}): ApiRequestConfigType => {
  const url = `${CUSTOMER_POSITIONS()}/${params.selectedPosition}/${
    params.selectedCommunity
  }/import_csv`;
  return {
    __typename: 'LegacyAPI',
    method: METHOD_POST,
    url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: params.formData,
  };
};

export const API_POST_editRankingMultiLocationTieringCSV = ({
  formData,
}: {
  formData: FormData;
}): ApiRequestConfigType => {
  const url = `${CUSTOMER_TEAMS()}/csv/import`;
  return {
    __typename: 'LegacyAPI',
    method: METHOD_POST,
    url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    body: formData,
  };
};
